import FolhaColaboradores from "../../components/folha-pagamento/colaboradores/FolhaColaboradores";

export default function () {
  return <FolhaColaboradores />;
}
